import styled from "styled-components"
import Logo from "../../assets/images/logo.png"
import { COLORS, SCREEN_SIZES } from "../../constants"
import { Container } from "reactstrap"
import { Helmet } from 'react-helmet';

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  padding: 20px;
  flex-direction: column;
  justify-content: top;
  height: 100vh;
`;
const StyledWhiteBg = styled.div`
  width: 70%;
  border-radius: 15px;
  background-color: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
      width: 100%;
    }
`;

export function AuthLayout({ children }) {
    return (
        <>
            <Helmet>
                <style>{`body { background-color: ${COLORS.light_blue}; }`}</style>
            </Helmet>
            <StyledContainer>
                <img className="mb-2" src={Logo} alt="Logo" width={230} />
                <StyledWhiteBg className="position-relative">
                    {children}
                </StyledWhiteBg>
            </StyledContainer>
        </>
    );
}